export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_SERVICE = 'online_ordering';
